import { dcFactory } from '@deleteagency/dc';
import 'general/img/logos/winkworth-logo.svg';
import Footer from './js/footer.component';
import './scss/index.scss';

dcFactory.register(Footer);
